import { defineQuery } from 'next-sanity'

export const careersVideoBlockFields = `
  _id,
  _type,
  videoEmbed,
  title,
  backgroundColor
`

export const CAREERS_VIDEO_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "careers-video-block"][0]{
    ${careersVideoBlockFields}
  }
`)
